import waja from 'waja';

const campaignCallbacks = [];
let loadedCampaigns = null;
let lastLoadTrigger = 0;

function getCampaigns (callback) {
	const now = Date.now();
	if ((now - lastLoadTrigger) / 1000 >  60 * 5) { // Om senaste laddningen var för 5+ min sedan så hämtar vi igen
		lastLoadTrigger = now;
		campaignCallbacks.push(callback);

		waja.get('webhallen-financing/campaign')
			.on('success', res => {
				loadedCampaigns = res.data.campaigns;
				for (const cb of campaignCallbacks) {
					cb(loadedCampaigns);
				}
				campaignCallbacks.length = 0; // Rensar arrayen
			})
			.useCdn(true)
			.go();
	} else if (loadedCampaigns) {
		callback(loadedCampaigns);
	} else {
		campaignCallbacks.push(callback);
	}
};

/**
 * @param interestRate - ränta i hela procent (mao anv 100 för 100%, inte 1.0)
 */
function calculateMonthlyCost (purchaseSum, arrangementFee, numPayments, interestRate, settlementFee) {
	arrangementFee = parseFloat(arrangementFee) || 0;
	interestRate = (parseFloat(interestRate) || 0.0000001) * 0.01;
	settlementFee = parseFloat(settlementFee) || 0;

	const periodrate = interestRate * 30 / 365; // @TODO bör vi räkna med skottår?
	const cost = (Math.round(purchaseSum * periodrate / (1.0 - Math.pow(1.0 + periodrate, -numPayments)) + ((arrangementFee + (settlementFee * numPayments)) / numPayments)));

	// @TODO ta bort, men smidigt för felsökning till en början console.log(purchaseSum, arrangementFee, numPayments, interestRate, settlementFee, cost);
	return cost;
}

function getLowestMonthlyCost (purchaseSum, callback) {
	getCampaigns(campaigns => {
		let lowestMonthlyCost = Infinity;
		let bestCampaign = null;

		for (const campaign of campaigns) {
			if (! campaign.numberOfPayments) {
				continue;
			}
			if (purchaseSum < 300 || (campaign.minimumOrderAmount && purchaseSum < campaign.minimumOrderAmount)) {
				continue;
			}
			const monthlyCost = calculateMonthlyCost(purchaseSum, campaign.arrangementFee, campaign.numberOfPayments, campaign.interestRate, campaign.settlementFee);
			if (monthlyCost < lowestMonthlyCost) {
				lowestMonthlyCost = monthlyCost;
				bestCampaign = campaign;
			}
		}

		if (lowestMonthlyCost === Infinity) {
			lowestMonthlyCost = null;
		} else if (lowestMonthlyCost < 50) {
			lowestMonthlyCost = 50;
		}

		callback({
			campaign: bestCampaign,
			monthlyCost: lowestMonthlyCost,
		});
	});
};

export default {
	getLowestMonthlyCost,
	calculateMonthlyCost,
	getCampaigns,
};
